import paths from "@icarius-router/paths";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("formCode"),
            field: 'code',
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("formType"),
            field: 'typeString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("jobGroup"),
            field: 'groupString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("formName"),
            field: 'name',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("evaluatesSpecificSkills"),
            field: 'evaluateSpecificSkillsString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("evaluatesTransversalCompetencies"),
            field: 'evaluateTransversalSkillsString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("evaluatesOrganizationObjectives"),
            field: 'evaluateOrganizationalTargetsString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("evaluatePersonalObjectives"),
            field: 'evaluatePersonalTargetsString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("evaluatePotential"),
            field: 'evaluatePotentialString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("competenciesWeighted"),
            field: 'skillsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("specificCompensationWeights"),
            field: 'specificSkillsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("crossFunctionalPond"),
            field: 'transversalSkillsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("weightedObjectives"),
            field: 'targetsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("organizationObjectivesPoints"),
            field: 'organizationalTargetsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("setPersonalObjectives"),
            field: 'personalTargetsWeight',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("competencyScaleType"),
            field: 'skillsScaleString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("objectiveScaleType"),
            field: 'targetsScaleString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("potentialScaleType"),
            field: 'potentialScaleString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("viewOnlyObjectives"),
            field: 'targetsOnlyVisualizationString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.performanceForms],
        config: {
            headerName: getLocalizedString("rateObjectivesWithPercentage"),
            field: 'targetsWithPercentageString',
            filter: "agSetColumnFilter",
        }
    },
]